import React, { FunctionComponent } from 'react'
import { Line, Path, Rect, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Events Icon with calendar used for events navigation.
 * Supports outlined (default) and filled (selected) states.
 */
export const EventsIcon: FunctionComponent<EventsIconProps> = ({ size = 32, fillColor, isFilled = false }) => {
  const { colors } = useTheme()
  const color = fillColor || colors.iconDefault

  if (isFilled) {
    return (
      <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
        {/* Calendar body with divider and day dot cutouts (evenodd) */}
        <Path
          fillRule='evenodd'
          d='M7 5.71 H25 A3 3 0 0 1 28 8.71 V26.59 A3 3 0 0 1 25 29.59 H7 A3 3 0 0 1 4 26.59 V8.71 A3 3 0 0 1 7 5.71 Z M5.75 11.03 H26.54 V13.03 H5.75 Z M9.02 16 H12 V18.98 H9.02 Z M9.02 21 H12 V23.98 H9.02 Z M14.65 16 H17.63 V18.98 H14.65 Z M14.65 21 H17.63 V23.98 H14.65 Z M20.28 16 H23.26 V18.98 H20.28 Z'
          fill={color}
        />
        {/* Calendar rings */}
        <Line x1={9.78} y1={3.3} x2={9.78} y2={6.22} stroke={color} strokeWidth={2} strokeLinecap='round' />
        <Line x1={22.34} y1={3.3} x2={22.34} y2={6.22} stroke={color} strokeWidth={2} strokeLinecap='round' />
      </Svg>
    )
  }

  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
      {/* Calendar body */}
      <Rect x={4} y={5.71} width={24} height={23.88} rx={3} fill='none' stroke={color} strokeWidth={2} />
      {/* Calendar rings */}
      <Line x1={9.78} y1={3.3} x2={9.78} y2={6.22} stroke={color} strokeWidth={2} strokeLinecap='round' />
      <Line x1={22.34} y1={3.3} x2={22.34} y2={6.22} stroke={color} strokeWidth={2} strokeLinecap='round' />
      {/* Divider line */}
      <Line x1={5.75} y1={12.03} x2={26.54} y2={12.03} stroke={color} strokeWidth={2} />
      {/* Calendar day dots */}
      <Rect x={9.02} y={16} width={2.98} height={2.98} rx={0.5} fill={color} />
      <Rect x={9.02} y={21} width={2.98} height={2.98} rx={0.5} fill={color} />
      <Rect x={14.65} y={16} width={2.98} height={2.98} rx={0.5} fill={color} />
      <Rect x={14.65} y={21} width={2.98} height={2.98} rx={0.5} fill={color} />
      <Rect x={20.28} y={16} width={2.98} height={2.98} rx={0.5} fill={color} />
    </Svg>
  )
}

export type EventsIconProps = {
  size?: number
  fillColor?: string
  isFilled?: boolean
}
